import { render } from "./BankDeposit.vue?vue&type=template&id=787975b6&ts=true"
import script from "./BankDeposit.vue?vue&type=script&lang=ts"
export * from "./BankDeposit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__